// extracted by mini-css-extract-plugin
export default {"Container":"AsideHeader_Container__Fa-Vy","Heading":"AsideHeader_Heading__opk92"};